import {DeviceSize} from '../../theme/helpers';
import {useStyles} from '../../hooks/styles';

export const GetStyle = (imageHeight: number) => {
  return useStyles(({theme, addShadow, mediaOnly}) => ({
    container: {
      ...addShadow({
        width: 0,
        height: 2,
        radius: 10,
        opacity: 0.08,
      }),
      borderRadius: 5,
      backgroundColor: theme.color.backgroundMenuColor,
      overflow: 'hidden',
      paddingBottom: 20,
    },
    textContainer: {
      ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 12}, {paddingHorizontal: 16}),
      paddingTop: 16,
      flexGrow: 1,
    },
    image: {
      height: imageHeight,
    },
    date: {
      color: theme.color.labelText,
      height: 21,
      marginBottom: 8,
    },
    description: {
      color: theme.color.textColor,
      paddingTop: 10,
      marginBottom: 17,
    },
    button: {
      width: 200,
      height: 36,
      alignSelf: 'center',
    },
    textHeader: {
      marginBottom: 10,
    },
  }));
};
